<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>
        <!-- Título -->
        <div class="atendimento">
            <h1 class="title">{{ $t('vendas-por-periodo') }}</h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <a>{{ $t('vendas') }}</a>
                    </li>
                    <li>
                        <a>{{ $t('relatorios') }}</a>
                    </li>
                    <li>
                        <a href="#" aria-current="page">{{ $t('vendas-por-periodo') }}</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="search-and-filter">
            <div class="columns is-variables is-desktop">
                <div class="column header-search is-2">
                    <vss-select
                        ref="periodoInput"
                        v-model="periodo"
                        :options="periodoOpts"
                        :height="40"
                        @input="updatePeriodo"
                        ml-labels
                        no-clearfix
                        title="periodo"
                        tooltipLabel="msg-escolha-dia-ou-mes"
                    />
                </div>
                <div class="column is-2">
                    <vss-select
                        title="tipo-pedido"
                        placeholder="selecione"
                        :options="tipoPedidoList"
                        v-model="tipoPedidoSelected"
                        :loading="tipoPedidoLoading"
                        @search="carregarTipoPedido"
                        @input="debouncedOnSearch"
                        :height="40"
                        multiple
                        searchable
                        clearable
                        no-clearfix
                        :closeOnSelect="false"
                    >
                        <template #multiple-selected="{ selected }">
                            ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                        </template>
                    </vss-select>
                </div>
                <div v-if="isData">
                    <!-- Data Inicial-->
                    <div class="column data is-one-quarter">
                        <verified-date-picker
                            :dateType="'startDate'"
                            :value="datainicio"
                            :title="'data-inicio'"
                            @input="changeStartDate"
                        />
                    </div>
                    <!-- Data Final -->
                    <div class="column data is-one-quarter">
                        <verified-date-picker
                            :dateType="'endDate'"
                            :value="datafim"
                            :startDate="datainicio"
                            :title="'data-fim'"
                            @input="changeEndDate"
                        />
                    </div>
                </div>
                <!-- Não alterar b-datepicker para verified-date-picker! O formato aqui é MM/YYYY, enquanto 
                o verified-date-picker tem formato DD/MM/YYYY -->
                <div v-else>
                    <!-- Mes Inicial-->
                    <div class="column data is-one-quarter">
                        <label v-text="$t('mes-inicio')" />
                        <b-datepicker
                            class="dpicker-filter"
                            type="month"
                            :month-names="[
                                $t('january'),
                                $t('february'),
                                $t('march'),
                                $t('april'),
                                $t('may'),
                                $t('june'),
                                $t('july'),
                                $t('august'),
                                $t('september'),
                                $t('october'),
                                $t('november'),
                                $t('december'),
                            ]"
                            :date-formatter="(date) => $moment(date).format('MM/YYYY')"
                            v-model="mes.ini"
                            :mobile-native="false"
                            icon="calendar-today"
                        />
                    </div>
                    <!-- Mes Final -->
                    <div class="column data is-one-quarter">
                        <label v-text="$t('mes-fim')" />
                        <b-datepicker
                            class="dpicker-filter"
                            type="month"
                            :month-names="[
                                $t('january'),
                                $t('february'),
                                $t('march'),
                                $t('april'),
                                $t('may'),
                                $t('june'),
                                $t('july'),
                                $t('august'),
                                $t('september'),
                                $t('october'),
                                $t('november'),
                                $t('december'),
                            ]"
                            :date-formatter="(date) => $moment(date).format('MM/YYYY')"
                            v-model="mes.fim"
                            :mobile-native="false"
                            icon="calendar-today"
                        />
                    </div>
                </div>
                <div class="column is-2" v-if="exportacaoTipo && permissao.export">
                    <div class="mt-2-custom">
                        <div class="data-exporta" v-if="exportacaoTipo.exportacsv == 1">
                            <b-button
                                class="mr-2 float-right"
                                type="is-primary"
                                icon-right="google-spreadsheet"
                                @click="checkExport('csv')"
                                v-tippy
                                :title="$t('msg-tooltip-csv')"
                            />
                        </div>
                        <div class="data-exporta" v-if="exportacaoTipo.exportapdf == 1">
                            <b-button
                                class="float-right"
                                type="is-primary"
                                icon-right="file-pdf"
                                @click="checkExport('pdf')"
                                v-tippy
                                :title="$t('msg-tooltip-pdf')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- FILTROS EXTRAS -->
        <b-collapse class="card" animation="slide" @open="onFilterChange" @close="onFilterChange">
            <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                <div class="card-header-title">
                    <div class="filtro-header">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-right'" />
                        {{ $t('filtros') }}
                    </div>
                </div>
            </div>

            <div class="card-content page">
                <div class="columns">
                    <div class="column">
                        <!-- @85909 - necessario filtrar a forma de pagamento levando em 
                        consideracao a relacao com pedido/faturamento -->
                        <vss-select
                            title="tipo-analise"
                            ref="atributoInput"
                            v-model="tipoAnalise"
                            :options="tipoAnaliseOpts"
                            @onBlurFunction="loadFormaPagto"
                            :height="30"
                            ml-labels
                            no-clearfix
                        />
                    </div>
                    <div class="column">
                        <vss-select
                            title="atributo"
                            ref="atributoInput"
                            v-model="atributo"
                            :options="atributoOpts"
                            :height="30"
                            @input="updateAtributo"
                            ml-labels
                            no-clearfix
                        />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vss-select
                            ref="vendedorInput"
                            class="smaller no-clear"
                            v-model="vendedoresSelected"
                            :options="vendedoresOptions"
                            :loading="vendedoresLoading"
                            @search="loadVendedores"
                            :height="30"
                            @input="clearSelect($event, 'vendedores')"
                            :closeOnSelect="false"
                            no-clearfix
                            multiple
                            clearable
                            searchable
                            title="vendedores"
                            tooltipLabel="msg-filtros-vendedores"
                        >
                            <template #multiple-selected="{ selected }">
                                ({{
                                    selected && selected.length > 0 ? selected.length : $t('todos')
                                }})
                            </template>
                        </vss-select>
                    </div>
                    <div class="column">
                        <vss-select
                            ref="atributoFilterInput"
                            class="smaller no-clear"
                            v-model="atributoOptionSelected"
                            :options="atributoOptions"
                            :loading="atributoLoading"
                            @search="loadAtributo"
                            :height="30"
                            @input="clearSelect($event, 'atributo')"
                            :closeOnSelect="false"
                            no-clearfix
                            multiple
                            clearable
                            searchable
                            :title="atributo != null ? 'atributo' : 'filtro'"
                            tooltipLabel="msg-filtros-atributoFilter"
                        >
                            <template #multiple-selected="{ selected }">
                                ({{
                                    selected && selected.length > 0 ? selected.length : $t('todos')
                                }})
                            </template>
                        </vss-select>
                    </div>
                </div>

                <div class="columns">
                    <div class="column">
                        <!-- @85909 - Tooltip inserida no filtro de forma de pagamento -
                        serao filtradas apenas as formas de pagamento que possuem relacao
                        com o tipo de analise (pedido ou faturamento) -->
                        <vss-select
                            ref="formaPagtoInput"
                            class="smaller no-clear"
                            v-model="formaPagamentoSelected"
                            :options="formaPagamentoSelect"
                            :loading="formaPagtoLoading"
                            @search="loadFormaPagto"
                            searchable
                            :height="30"
                            @input="clearSelect($event, 'formaPagto')"
                            :closeOnSelect="false"
                            no-clearfix
                            multiple
                            clearable
                            title="forma-pagamento"
                            tooltipLabel="msg-filtros-formaPagto"
                        >
                            <template #multiple-selected="{ selected }">
                                ({{
                                    selected && selected.length > 0 ? selected.length : $t('todos')
                                }})
                            </template>
                        </vss-select>
                    </div>
                    <div class="column">
                        <vss-select
                            title="status-pedido"
                            ref="statusInput"
                            class="smaller no-clear"
                            v-model="statusSelected"
                            :options="statusSelect"
                            :loading="statusLoading"
                            :height="30"
                            @input="clearSelect($event, 'status')"
                            :closeOnSelect="false"
                            no-clearfix
                            multiple
                            clearable
                        >
                            <template #multiple-selected="{ selected }">
                                ({{
                                    selected && selected.length > 0 ? selected.length : $t('todos')
                                }})
                            </template>
                        </vss-select>
                    </div>
                </div>
            </div>
        </b-collapse>
        <!-- Botões -->
        <div class="columns mt-2 mb-1">
            <div class="column is-6 has-text-centered">
                <button class="delete-btn pl-4 pr-4" @click="limparFiltros">
                    {{ $t('limpar-filtros') }}
                </button>
            </div>
            <div class="column is-6 has-text-centered">
                <button class="save-btn pl-4 pr-4" @click="pesquisar()">
                    {{ $t('pesquisar') }}
                </button>
            </div>
        </div>
        <div class="page results-x">
            <!-- Tabela -->
            <div class="table-results" v-if="tableData.length > 0 && !isSearching">
                <b-table
                    :data="itemsDataTable"
                    :key="tableKey"
                    :mobile-cards="false"
                    :height="tableHeight"
                    :backend-pagination="true"
                    :sticky-header="isFixedHeader"
                    :hoverable="true"
                >
                    <!-- Coluna de ID, NOME e IDENTIFICADORES DE LINHAS -->
                    <b-table-column class="atrib-col" :sticky="isFixedColumn">
                        <template v-slot:header>
                            <span class="is-clickable" @click="updateOrdem('nome', null)">
                                {{ $t(atributoTable) }}
                                <b-icon
                                    v-show="sortColumn != 'nome'"
                                    class="order-icon"
                                    icon="sort"
                                    size="is-small"
                                />
                                <b-icon
                                    v-show="sortColumn == 'nome' && sortOrder == 'asc'"
                                    class="order-icon"
                                    icon="sort-ascending"
                                    size="is-small"
                                />
                                <b-icon
                                    v-show="sortColumn == 'nome' && sortOrder == 'desc'"
                                    style="margin-right: 0px"
                                    class="order-icon"
                                    icon="sort-descending"
                                    size="is-small"
                                />
                            </span>
                        </template>
                        <template v-slot="props">
                            <div class="table-left">
                                <div class="item">
                                    {{ props.row.idItem }} - {{ props.row.nomeItem }}
                                </div>
                                <div class="atributos">
                                    <div
                                        class="atributo nome"
                                        v-for="(a, index) in visibleTableProps"
                                        :key="index"
                                    >
                                        {{ $t(a.label) }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </b-table-column>

                    <!-- COLUNAS DO PERIODO  -->
                    <b-table-column
                        v-for="(periodo, index) in periodosTable"
                        :key="index"
                        :label="
                            isData
                                ? periodo.dia + '/' + periodo.mes + '/' + periodo.ano
                                : $t(periodo.label) + '/' + periodo.ano
                        "
                        class="value-col"
                        numeric
                    >
                        <template v-slot:header>
                            <b-dropdown
                                aria-role="list"
                                position="is-bottom-left"
                                :append-to-body="true"
                                :mobile-modal="false"
                                can-close
                            >
                                <span class="is-clickable" slot="trigger">
                                    {{
                                        isData
                                            ? periodo.dia + '/' + periodo.mes + '/' + periodo.ano
                                            : $t(periodo.label) + '/' + periodo.ano
                                    }}
                                    <b-icon
                                        v-show="
                                            sortColumn !=
                                            (isData
                                                ? periodo.dia +
                                                  '/' +
                                                  periodo.mes +
                                                  '/' +
                                                  periodo.ano
                                                : mes.mes + '/' + mes.ano)
                                        "
                                        class="order-icon"
                                        icon="sort"
                                        size="is-small"
                                    />
                                    <b-icon
                                        v-show="
                                            sortColumn ==
                                                (isData
                                                    ? periodo.dia +
                                                      '/' +
                                                      periodo.mes +
                                                      '/' +
                                                      periodo.ano
                                                    : mes.mes + '/' + mes.ano) && sortOrder == 'asc'
                                        "
                                        class="order-icon"
                                        icon="sort-ascending"
                                        size="is-small"
                                    />
                                    <b-icon
                                        v-show="
                                            sortColumn ==
                                                (isData
                                                    ? periodo.dia +
                                                      '/' +
                                                      periodo.mes +
                                                      '/' +
                                                      periodo.ano
                                                    : mes.mes + '/' + mes.ano) &&
                                            sortOrder == 'desc'
                                        "
                                        class="order-icon"
                                        icon="sort-descending"
                                        size="is-small"
                                    />
                                </span>

                                <b-dropdown-item
                                    class="is-flex is-flex-vcenter"
                                    style="padding-right: 1rem"
                                    aria-role="listitem"
                                    v-for="(item, i) in getSortFields()"
                                    :key="i"
                                    @click="
                                        updateOrdem(
                                            isData
                                                ? periodo.dia.toString() +
                                                      '/' +
                                                      periodo.mes.toString() +
                                                      '/' +
                                                      periodo.ano.toString()
                                                : mes.mes + '/' + mes.ano,
                                            item.key
                                        )
                                    "
                                >
                                    <div class="drop-item">
                                        <span class="text" v-text="$t(item.label)" />
                                        <b-icon
                                            v-show="
                                                sortColumn ==
                                                    (isData
                                                        ? periodo.dia +
                                                          '/' +
                                                          periodo.mes +
                                                          '/' +
                                                          periodo.ano
                                                        : mes.mes + '/' + mes.ano) &&
                                                sortField == item.key &&
                                                sortOrder == 'asc'
                                            "
                                            class="item-icon"
                                            icon="chevron-up"
                                        />
                                        <b-icon
                                            v-show="
                                                sortColumn ==
                                                    (isData
                                                        ? periodo.dia +
                                                          '/' +
                                                          periodo.mes +
                                                          '/' +
                                                          periodo.ano
                                                        : mes.mes + '/' + mes.ano) &&
                                                sortField == item.key &&
                                                sortOrder == 'desc'
                                            "
                                            class="item-icon"
                                            icon="chevron-down"
                                        />
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </template>
                        <template v-slot="props">
                            <div class="table-data numeric">
                                <div class="atributos" v-if="isData">
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        <div v-if="a.key == 'qtdvendas' || a.key == 'qtditens'">
                                            {{
                                                getAttrDayMonthYear(
                                                    periodo.dia,
                                                    periodo.mes,
                                                    periodo.ano,
                                                    props.row,
                                                    a.key
                                                )
                                            }}
                                        </div>
                                        <div v-else>
                                            {{
                                                getDecimal(getAttrDayMonthYear(
                                                    periodo.dia,
                                                    periodo.mes,
                                                    periodo.ano,
                                                    props.row,
                                                    a.key
                                                ) , null, true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="atributos" v-else>
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        <div v-if="a.key == 'qtdvendas' || a.key == 'qtditens'">
                                            {{
                                                getAttrMonth(
                                                    periodo.mes,
                                                    periodo.ano,
                                                    props.row,
                                                    a.key
                                                )
                                            }}
                                        </div>
                                        <div v-else>
                                            {{
                                                getDecimal( getAttrMonth(
                                                    periodo.mes,
                                                    periodo.ano,
                                                    props.row,
                                                    a.key
                                                ) , null, true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </b-table-column>

                    <!-- COLUNA TOTAL -->
                    <b-table-column :label="$t('total')" class="value-col" numeric>
                        <template v-slot:header>
                            <b-dropdown
                                aria-role="list"
                                position="is-bottom-left"
                                :append-to-body="true"
                                :mobile-modal="false"
                            >
                                <span class="is-clickable" slot="trigger">
                                    {{ $t('total') }}
                                    <b-icon
                                        v-show="sortColumn != 'total'"
                                        class="order-icon"
                                        icon="sort"
                                        size="is-small"
                                    />
                                    <b-icon
                                        v-show="sortColumn == 'total' && sortOrder == 'asc'"
                                        class="order-icon"
                                        icon="sort-ascending"
                                        size="is-small"
                                    />
                                    <b-icon
                                        v-show="sortColumn == 'total' && sortOrder == 'desc'"
                                        class="order-icon"
                                        icon="sort-descending"
                                        size="is-small"
                                    />
                                </span>

                                <b-dropdown-item
                                    class="is-flex is-flex-vcenter"
                                    style="padding-right: 1rem"
                                    aria-role="listitem"
                                    v-for="(item, i) in getSortFields()"
                                    :key="i"
                                    @click="updateOrdem('total', item.key)"
                                >
                                    <div class="drop-item">
                                        <span class="text" v-text="$t(item.label)" />
                                        <b-icon
                                            v-show="
                                                sortColumn == 'total' &&
                                                sortField == item.key &&
                                                sortOrder == 'asc'
                                            "
                                            class="item-icon"
                                            icon="chevron-up"
                                        />
                                        <b-icon
                                            v-show="
                                                sortColumn == 'total' &&
                                                sortField == item.key &&
                                                sortOrder == 'desc'
                                            "
                                            class="item-icon"
                                            icon="chevron-down"
                                        />
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </template>
                        <template v-slot="props">
                            <div class="table-data numeric">
                                <div class="atributos" v-if="isData">
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        <div v-if="a.key == 'qtdvendas' || a.key == 'qtditens'">
                                            {{ getAttrDayMonthYear(0, 0, 0, props.row, a.key) }}
                                        </div>
                                        <div v-else>
                                            {{
                                                getDecimal(getAttrDayMonthYear(
                                                    0,
                                                    0,
                                                    0,
                                                    props.row,
                                                    a.key
                                                ) , null, true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="atributos" v-else>
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        <div v-if="a.key == 'qtdvendas' || a.key == 'qtditens'">
                                            {{ getAttrMonth(0, 0, props.row, a.key) }}
                                        </div>
                                        <div v-else>
                                            {{
                                                getDecimal(getAttrMonth(0, 0, props.row, a.key) , null, true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </b-table-column>

                    <!-- COLUNA CONTRIBUICAO  -->
                    <b-table-column :label="$t('perc-contribuicao')" class="value-col" numeric>
                        <template v-slot:header>
                            <span class="is-clickable" @click="updateOrdem('contribuicao', null)">
                                {{ $t('perc-contribuicao') }}
                                <b-icon
                                    v-show="sortColumn != 'contribuicao'"
                                    class="order-icon"
                                    icon="sort"
                                    size="is-small"
                                />
                                <b-icon
                                    v-show="sortColumn == 'contribuicao' && sortOrder == 'asc'"
                                    class="order-icon"
                                    icon="sort-ascending"
                                    size="is-small"
                                />
                                <b-icon
                                    v-show="sortColumn == 'contribuicao' && sortOrder == 'desc'"
                                    class="order-icon"
                                    icon="sort-descending"
                                    size="is-small"
                                />
                            </span>
                        </template>
                        <template v-slot="props">
                            {{ formatContribuicao(props.row.contribuicao) }}
                        </template>
                    </b-table-column>

                    <!-- RODAPÉ COM O TOTALIZADOR -->
                    <template slot="footer">
                        <th
                            :class="{
                                'is-sticky': isFixedColumn,
                            }"
                        >
                            <div class="table-left">
                                <div class="cliente">
                                    {{ $t('total') }}
                                </div>
                                <div class="atributos">
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        {{ $t(a.label) }}
                                    </div>
                                </div>
                            </div>
                        </th>
                        <th v-for="(periodo, index) in periodosTable" :key="index">
                            <div class="table-data numeric">
                                <div class="atributos" v-if="totalDataTable && isData">
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        <div v-if="a.key == 'qtdvendas' || a.key == 'qtditens'">
                                            {{
                                                getAttrDayMonthYear(
                                                    periodo.dia,
                                                    periodo.mes,
                                                    periodo.ano,
                                                    totalDataTable,
                                                    a.key
                                                )
                                            }}
                                        </div>
                                        <div v-else>
                                            {{
                                                getDecimal(getAttrDayMonthYear(
                                                    periodo.dia,
                                                    periodo.mes,
                                                    periodo.ano,
                                                    totalDataTable,
                                                    a.key
                                                ) , null, true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="atributos" v-else-if="totalDataTable">
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        <div v-if="a.key == 'qtdvendas' || a.key == 'qtditens'">
                                            {{
                                                getAttrMonth(
                                                    periodo.mes,
                                                    periodo.ano,
                                                    totalDataTable,
                                                    a.key
                                                )
                                            }}
                                        </div>
                                        <div v-else>
                                            {{
                                                getDecimal(getAttrMonth(
                                                    periodo.mes,
                                                    periodo.ano,
                                                    totalDataTable,
                                                    a.key
                                                ) , null, true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="table-data numeric">
                                <div class="atributos" v-if="totalDataTable && isData">
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        <div v-if="a.key == 'qtdvendas' || a.key == 'qtditens'">
                                            {{
                                                getAttrDayMonthYear(0, 0, 0, totalDataTable, a.key)
                                            }}
                                        </div>
                                        <div v-else>
                                            {{
                                                getDecimal(getAttrDayMonthYear(
                                                    0,
                                                    0,
                                                    0,
                                                    totalDataTable,
                                                    a.key
                                                ) , null, true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="atributos" v-else-if="totalDataTable">
                                    <div
                                        class="atributo"
                                        v-for="(a, i) in visibleTableProps"
                                        :key="i"
                                    >
                                        <div v-if="a.key == 'qtdvendas' || a.key == 'qtditens'">
                                            {{ getAttrMonth(0, 0, totalDataTable, a.key) }}
                                        </div>
                                        <div v-else>
                                            {{
                                                getDecimal(getAttrMonth(
                                                    0,
                                                    0,
                                                    totalDataTable,
                                                    a.key
                                                ) , null, true)
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="table-data numeric">
                                {{ totalDataTable.contribuicao * 100 }}%
                            </div>
                        </th>
                    </template>
                </b-table>
            </div>
            <!-- Loader -->
            <div v-show="isSearching" class="searching-loader">
                <svg class="loading">
                    <use :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"></use>
                </svg>
                <div>{{ $t('carregando-dados') }}...</div>
            </div>
            <!-- Mensagem 'não há dados' e ajuda de utilização -->
            <div v-show="(firstTime || noData) && !isSearching" class="searching-loader">
                <svg class="bigicon">
                    <use
                        v-if="firstTime"
                        :xlink:href="require('@/assets/img/icons/magnify.svg') + '#layer'"
                    ></use>
                    <use
                        v-else
                        :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"
                    ></use>
                </svg>
                <div v-if="firstTime">
                    {{ $t('descricao-ajuda-filtro-relatorio') }}
                </div>
                <div v-else>
                    {{ $t('no-data') }}
                </div>
            </div>
        </div>
        <b-modal
            class="export-opcoes"
            :active.sync="isShowingTitle"
            style="z-index: 1000"
            @close="isShowingTitle = false"
        >
            <div class="modal-card modal-default center" style="max-width: 580px">
                <section class="modal-card-body">
                    <div class="listing-header">
                        <div class="title-breadcrumb center">
                            <h1 class="title">
                                {{ $t('exportacao-dados') }}
                            </h1>
                        </div>
                    </div>
                    <div class="columns p-4">
                        {{ $t('title-exp') }}
                    </div>
                    <div class="columns is-full mx-1">
                        <div class="titulo-input">
                            <v-input
                                v-model="tituloExportacao"
                                :maxlength="100"
                                :title="'titulo-exp'"
                                :msg="'msg-campo-obrigatorio'"
                            />
                        </div>
                    </div>
                    <div class="columns ok">
                        <div class="form-buttons2">
                            <button
                                class="delete-btn"
                                type="button"
                                @click="isShowingTitle = false"
                            >
                                {{ $t('cancelar') }}
                            </button>
                            <button class="save-btn" type="button" @click="saveExportacao()">
                                {{ $t('exportar-rel') }}
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>
        <PaginationViewer
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            @change="updatePagination"
        />
    </div>
</template>

<script>
import FormaPagtoService from '@/services/FormaPagtoService';
import FiltroRelatorioService from '@/services/FiltroRelatorioService';
import VendasRelPeriodoService from '@/services/VendasRelPeriodoService';
import ColaboradorService from '@/services/ColaboradorService';
import Message from '@/models/Message';
import PedidoService from '@/services/PedidoService';
import ExportacaoService from '@/services/ExportacaoService';
import ExportacaoDadosService from '@/services/ExportacaoDadosService';
import ExportacaoLogService from '@/services/ExportacaoLogService';
import ExportacaoTipoService from '@/services/ExportacaoTipoService';
import TipoPedidoService from '@/services/vendas/TipoPedidoService.js';

/*
    @85909 - a seguinte tela precisa suportar os períodos de dia e mes e por conta disso
    as funções utilizadas na montagem da tabela precisaram ser duplicadas, por conta
    das classes infoMes e infoDias que suportam respetivamente cada um dos períodos.
*/
export default {
    data() {
        const monthKeys = [
            'january',
            'february',
            'march',
            'april',
            'may',
            'june',
            'july',
            'august',
            'september',
            'october',
            'november',
            'december',
        ];
        return {
            monthKeys,
            dataService: null,
            tipoPedidoService: new TipoPedidoService(this.$http, this.$router),
            serviceFormaPagto: null,
            filtroService: null,
            filtroIsOpen: true,
            ini: '',
            fim: '',
            isLoading: false,
            mes: {},
            meses: [],
            atributoOpts: ['cliente', 'produto'],
            tipoAnaliseOpts: ['pedido', 'faturamento'],
            periodoOpts: ['mes', 'dia'],
            atributo: null,
            tipoAnalise: null,
            periodo: null,
            atributoTable: null,
            atributoOptions: [],
            atributoOptionSelected: null,
            atributoLoading: false,
            sortColumn: null,
            sortField: null,
            sortOrder: 'desc',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50],
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
            },
            isFixedHeader: false,
            isFixedColumn: true,
            tableWidth: '',
            tableHeight: '',
            vendedoresOptions: [],
            vendedoresSelected: null,
            vendedoresLoading: false,
            formaPagtoLoading: false,
            current: null,
            tableData: [],
            tableExportacao: [],
            tableKey: 0,
            periodosTable: [],
            showTable: true,
            tableProps: [
                {
                    key: 'qtdvendas',
                    label: 'qtd-vendas',
                    visible: true,
                },
                {
                    key: 'totalvendas',
                    label: 'total-vendas',
                    visible: true,
                },
                {
                    key: 'ticketmedio',
                    label: 'ticket-medio',
                    visible: true,
                },
            ],
            firstTime: true,
            noData: false,
            isSearching: false,
            msgs: [],
            permissao: {},
            datainicio: this.$moment().subtract(1, 'month').toDate(),
            datafim: new Date(),
            filtros: {},
            formaPagamentoSelected: null,
            formaPagamentoSelect: [],
            isData: false,
            statusSelect: [],
            statusSelectCompleto: [], // onde armazena todos os registros.
            statusSelected: null,
            statusLoading: false,
            pedidoService: null,
            dicsStatus: {
                N: 'nao-enviado',
                E: 'processando',
                S: 'transmitido',
                C: 'cancelado',
                ED: 'em-edicao',
                AP: 'aguardando-aprovacao',
                A: 'aprovado',
                F: 'faturado',
                D: 'deletado',
                EI: 'problema-integracao-erp',
            },
            isExporting: false,
            exportacaoService: null,
            exportacaoDadosService: null,
            exportacaoLogService: null,
            exportacaoTipoService: null,
            isShowingTitle: false,
            tituloExportacao: null,
            exportacaoTipo: {},
            isSaving: false,
            tipoPedidoList: [],
            tipoPedidoSelected: [],
            tipoPedidoLoading: false,
        };
    },

    created() {
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'relatorio-analitico',
            'relatorio-vendas-vendas-por-periodo'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'vendas-por-periodo' },
            });

        this.dataService = new VendasRelPeriodoService(this.$http, this.$router);
        this.filtroService = new FiltroRelatorioService(this.$http, this.$router);
        this.colaboradorService = new ColaboradorService(this.$http, this.$router);
        this.serviceFormaPagto = new FormaPagtoService(this.$http, this.$router);
        this.pedidoService = new PedidoService(this.$http, this.$router);
        this.exportacaoService = new ExportacaoService(this.$http, this.$router);
        (this.exportacaoDadosService = new ExportacaoDadosService(this.$http, this.$router)),
            (this.exportacaoLogService = new ExportacaoLogService(this.$http, this.$router)),
            (this.exportacaoTipoService = new ExportacaoTipoService(this.$http, this.$router)),
            (this.mes.ini = this.$moment().subtract(1, 'month').toDate());
        this.mes.fim = this.$moment().toDate();

        this.atributo = this.atributoOpts[0];
        this.tipoAnalise = this.tipoAnaliseOpts[0];
        this.periodo = this.periodoOpts[0];
        this.carregaExportacaoTipo();

        this.sortField = null;
        this.sortColumn = 'contribuicao';
        this.sortOrder = 'desc';
    },
    methods: {
        carregaExportacaoTipo() {
            // Indica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela('VENDASPERIODO').then((body) => {
                if (body.content) {
                    this.exportacaoTipo = body.content;
                }
            });
        },
        checkExport(tipo) {
            if (this.tableData.length > 0) {
                this.tipoExportacao = tipo;
                this.isShowingTitle = true;
            } else {
                this.$root.showMessage('alert', 'msg-valida-tabela');
            }
        },
        changeStartDate(date) {
            this.datainicio = date;
        },
        changeEndDate(date) {
            this.datafim = date;
        },
        updatePagination(value) {
            this.pagination.currentPage = value.currentPage;
            this.pagination.perPage = value.perPage;
            this.pagination.resetPagination = false;
            this.getDados(this.pagination.currentPage);
        },
        formatContribuicao(contrib) {
            if (contrib) {
                return +(contrib * 100).toFixed(2) + '%';
            } else {
                return '0%';
            }
        },
        // para cada dia, necessário pegar sua referência para a quantidade, vendas e ticket medio presente em infoDias
        getAttrDayMonthYear(dia, mes, ano, row, attr) {
            let anoMesDia = [];
            anoMesDia = row.infoDias.filter((d) =>
                dia != 0 && mes != 0
                    ? d.anoMesDia.dia == dia && d.anoMesDia.mes == mes && d.anoMesDia.ano == ano
                    : d.anoMesDia.dia == 0 && d.anoMesDia.mes == 0
            );

            if (anoMesDia.length > 0) {
                return anoMesDia[0][attr];
            } else {
                return 0;
            }
        },
        // para cada mes, necessário pegar sua referência para a quantidade, vendas e ticket medio presente em infosMes
        getAttrMonth(mes, ano, row, attr) {
            let m = [];

            m = row.infosMes.filter((d) =>
                mes != 0 ? d.mesAno.mes == mes && d.mesAno.ano == ano : d.mesAno.mes == 0
            );

            if (m.length > 0) {
                return m[0][attr];
            } else {
                return 0;
            }
        },
        // funcao necessaria para montar a formatacao das colunas de mes
        getMonthsArray() {
            // O início tem que vir antes do fim, validado antes de chamar esta função
            let m = [];
            let i = this.filtros.ini.split('/'); // i[0] = yyyy, i[1] = dd
            let f = this.filtros.fim.split('/');

            while (i[0] != f[0] || i[1] != f[1]) {
                m.push({
                    label: this.monthKeys[i[1] - 1],
                    mes: parseInt(i[1]),
                    ano: parseInt(i[0]),
                });

                i[1]++;

                if (i[1] > 12) {
                    i[1] = 1;
                    i[0]++;
                }
            }

            m.push({
                label: this.monthKeys[f[1] - 1],
                mes: parseInt(f[1]),
                ano: parseInt(f[0]),
            });

            return m;
        },
        // funcao necessária para montar a formatacao das colunas de dia
        getDaysMonthYearArray() {
            // O início tem que vir antes do fim, validado antes de chamar esta função
            let dayMonthYear = [];
            let inicio = this.filtros.ini.split('-');
            // inicio[0] = yyyy, inicio[1] = mm e inicio[2] = dd
            let fim = this.filtros.fim.split('-');

            //construir um array conforme a quantidade de dias entre dois meses
            let getDays = (year, month) => new Date(year, month, 0).getDate();
            let diffDaysOfMonth = getDays(inicio[0], inicio[1]);
            let month = inicio[1];
            let day = inicio[2];

            while (inicio[0] != fim[0] || inicio[1] != fim[1] || inicio[2] != fim[2]) {
                dayMonthYear.push({
                    ano: parseInt(inicio[0]),
                    mes: month,
                    dia: day,
                });

                inicio[2]++;

                if (inicio[2] > diffDaysOfMonth) {
                    inicio[2] = 1;
                    inicio[1]++;
                    if (inicio[1] > 12) {
                        inicio[1] = 1;
                        inicio[0]++;
                    }
                    month = inicio[1] < 10 ? '0' + inicio[1] : inicio[1];
                    diffDaysOfMonth = getDays(inicio[0], inicio[1]);
                }
                day = inicio[2] < 10 ? '0' + inicio[2] : inicio[2];
            }

            dayMonthYear.push({
                ano: parseInt(inicio[0]),
                mes: month,
                dia: day,
            });

            return dayMonthYear;
        },
        pesquisar() {
            this.filtroIsOpen = false;
            this.sortField = null;
            this.sortColumn = 'contribuicao';
            this.sortOrder = 'desc';
            this.getDados(1);
        },
        getDados(currentPage) {
            if (this.validate()) {
                if (currentPage == 1 && this.pagination.currentPage != 1)
                    this.pagination.resetPagination = true;

                this.pagination.currentPage = currentPage
                    ? currentPage
                    : this.pagination.currentPage;
                this.isSearching = true;

                if (this.firstTime) {
                    this.firstTime = false;
                }

                this.filtros.tipoanalise = this.tipoAnalise;
                this.filtros.atributo = this.atributo;
                this.filtros.idsvendedores =
                    this.vendedoresSelected != null ? this.vendedoresSelected.map((v) => v.id) : [];
                this.filtros.tiposPedido = this.tipoPedidoSelected.map((v) => v.id);
                this.filtros.idsitens =
                    this.atributoOptionSelected != null
                        ? this.atributoOptionSelected.map((a) => a.id)
                        : [];
                this.filtros.sortcolumn = this.sortColumn;
                this.filtros.sortfield = this.sortField;
                this.filtros.sortorder = this.sortOrder;
                // @84445 - Inserida a verificação de user admin, para evitar a listagem de pedidos de empresas não vinculadas ao
                //          usuário comum
                if (!this.$store.state.user.admin) {
                    this.filtros.empresas = this.$store.state.user.empresas.map((e) => e.idempresa);
                }
                this.filtros.idformapagto =
                    this.formaPagamentoSelected != null
                        ? this.formaPagamentoSelected.map((v) => v.id)
                        : [];
                this.filtros.data = this.isData;
                this.filtros.idstatuspedido =
                    this.statusSelected != null ? this.statusSelected.map((v) => v.id) : [];

                this.carregarDados(this.pagination.currentPage - 1, this.pagination.perPage);
            }
        },
        carregarDados(currentPage, perPage) {
            let objWithIdIndex = this.tableProps.findIndex((obj) => obj.key == 'qtditens');
            if (objWithIdIndex > -1) {
                if (this.atributo === 'cliente') {
                    this.tableProps.splice(objWithIdIndex, 1);
                }
            } else {
                if (this.atributo === 'produto') {
                    this.tableProps.unshift({ key: 'qtditens', label: 'qtd-itens', visible: true });
                }
            }

            this.dataService
                .loadItens(currentPage, perPage, this.filtros)
                .then((value) => {
                    this.pagination.totalRows = value.totalElements;
                    if (value.content) {
                        this.mapData(value.content);
                    }
                    this.noData = this.pagination.totalRows <= 0;
                })
                .catch((error) => {
                    console.error('Erro ao trazer dados de itens.', error);
                    this.showMessage('error', 'msg-erro-relatorio');
                    this.noData = true;
                    this.pagination.totalRows = 0;
                    this.pagination.currentPage = 1;
                    this.tableData = [];
                })
                .finally(() => {
                    this.isSearching = false;
                });
        },
        mapData(r) {
            this.periodosTable = this.isData ? this.getDaysMonthYearArray() : this.getMonthsArray();
            this.tableData = r;
            this.noData = r.length == 0;
            this.atributoTable = this.atributo;
            this.tableKey++;
            this.resize();
        },
        updateAtributo(newv) {
            this.atributo = newv;
            this.atributoOptionSelected = null;
            this.atributoOptions = [];
            this.loadAtributo('');
        },
        // funcao necessaria para limpar todos os dados referentes a mudanca de periodo no input periodo
        updatePeriodo() {
            this.isData = this.periodo == 'dia' ? true : false;
            this.tableData = [];
            this.periodosTable = [];
            this.firstTime = true;
            this.noData = false;
            this.pagination.totalRows = 0;
            this.pagination.resetPagination = false;
        },
        updateOrdem(sortColumn, sortField) {
            if (
                (sortColumn == 'nome' ||
                    sortColumn.includes('/') ||
                    sortColumn == 'total' ||
                    sortColumn == 'contribuicao') &&
                (sortField == null ||
                    sortField == 'qtditens' ||
                    sortField == 'qtdvendas' ||
                    sortField == 'totalvendas' ||
                    sortField == 'ticketmedio')
            ) {
                if (this.sortColumn == sortColumn && this.sortField == sortField) {
                    // se já estava sendo ordenado por essa coluna, então a ordenação deve ser invertida
                    if (this.sortOrder == 'desc') {
                        this.sortOrder = 'asc';
                    } else {
                        this.sortOrder = 'desc';
                    }
                } else {
                    // se está sendo ordenado por um campo novo
                    this.sortOrder = 'desc';
                }

                this.sortColumn = sortColumn;
                this.sortField = sortField;
            } else {
                // se nao for alguma das possibilidades (algo errado), seta os valores padrão para a ordenação
                this.sortColumn = 'contribuicao';
                this.sortField = null;
                this.sortOrder = 'desc';
            }

            if (this.pagination.totalRows > 1) {
                this.getDados(this.pagination.currentPage);
            }
        },
        getSortFields() {
            return this.visibleTableProps.concat({
                key: 'semordenacao',
                label: 'sem-ordenacao',
                visible: true,
            });
        },
        loadVendedores(q) {
            this.vendedoresLoading = true;
            this.colaboradorService
                .findListAssociated(q)
                .then((r) => {
                    this.vendedoresOptions = r.content.map((v) => {
                        return {
                            id: v.id,
                            label: v.nome.toLocaleUpperCase(),
                        };
                    });
                })
                .catch((e) => {
                    console.error('Erro ao carregar vendedores.', e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        loadFormaPagto(q) {
            this.formaPagtoLoading = true;
            this.serviceFormaPagto
                .findAllCombo(q)
                .then((r) => {
                    this.formaPagamentoSelect = r.content.map((v) => {
                        return {
                            id: v.id,
                            label: v.descricao.toLocaleUpperCase(),
                        };
                    });
                })
                .catch((e) => {
                    console.error('Erro ao carregar forma de pagamento.', e);
                })
                .finally((_) => {
                    this.formaPagtoLoading = false;
                });
        },
        loadAtributo(q) {
            this.atributoLoading = true;
            if (this.atributo === 'produto') {
                this.filtroService
                    .findAllComboProduto(20, q)
                    .then((r) => {
                        if (r.status != 200) {
                            console.error(
                                `Erro com status ${r.status} ao realizar pesquisa por produto. Termo: [${q}].`
                            );
                            this.atributoOptions = [];
                        } else {
                            this.atributoOptions = r.content.map((v) => {
                                return {
                                    id: v.id,
                                    label: v.descricao.toLocaleUpperCase(),
                                };
                            });
                        }
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa por produto. Termo: [${q}].`, e);
                        this.atributoOptions = [];
                    })
                    .finally(() => {
                        this.atributoLoading = false;
                    });
            } else if (this.atributo === 'cliente') {
                this.filtroService
                    .findAllClienteVendas(20, q)
                    .then((r) => {
                        if (r.status != 200) {
                            console.error(
                                `Erro com status ${r.status} ao realizar pesquisa por cliente. Termo: [${q}].`
                            );
                            this.atributoOptions = [];
                        } else {
                            this.atributoOptions = r.content.map((v) => {
                                return {
                                    id: v.id,
                                    label: v.rsocial.toLocaleUpperCase(),
                                };
                            });
                        }
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa por cliente. Termo: [${q}].`, e);
                        this.atributoOptions = [];
                    })
                    .finally(() => {
                        this.atributoLoading = false;
                    });
            }
        },
        loadStatusPedido() {
            this.statusLoading = true;

            this.pedidoService
                .getStatusPedidoCombo()
                .then((r) => {
                    Object.entries(r.content).forEach(([key, val]) => {
                        let texto = val.toUpperCase();
                        this.statusSelectCompleto.push({
                            id: key,
                            label:
                                texto in this.dicsStatus
                                    ? this.$t(this.dicsStatus[texto]).toUpperCase()
                                    : texto,
                        });
                    });
                    this.statusSelect = Object.assign([], this.statusSelectCompleto);
                })
                .catch((e) => {
                    console.error('Erro ao carregar o status do pedido.', e);
                })
                .finally((_) => {
                    this.statusLoading = false;
                });
        },
        // validacao do periodo - a extensao dos dados fez com que o limite para o perido mes fosse de 2 anos,
        // ja o de dias, de 1 mes.
        validate() {
            if (this.isData) {
                this.filtros.ini = this.datainicio
                    ? this.$moment(this.datainicio).format('YYYY-MM-DD')
                    : null;
                this.filtros.fim = this.datafim
                    ? this.$moment(this.datafim).format('YYYY-MM-DD')
                    : null;
                return this.validateDatas();
            } else {
                this.filtros.ini = this.mes.ini
                    ? this.$moment(this.mes.ini).format('YYYY/MM')
                    : null;
                this.filtros.fim = this.mes.fim
                    ? this.$moment(this.mes.fim).format('YYYY/MM')
                    : null;
                return this.validateMeses();
            }
        },
        carregarTipoPedido(query = null) {
            this.tipoPedidoLoading = true;
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.tipoPedidoService
                .findAllCombo(query)
                .then(this.mapTipoPedidoList)
                .then((value) => {
                    if (value != null) {
                        this.tipoPedidoList = value;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.tipoPedidoLoading = false;
                });
        },
        mapTipoPedidoList(response) {
            return response.content.map((m) => {
                return {
                    id: m.id,
                    label: m.descricao,
                };
            });
        },
        validateMeses() {
            let valido = true;
            let inicio = this.$moment(this.mes.ini);
            let fim = this.$moment(this.mes.fim);

            if (fim.isBefore(inicio)) {
                this.$root.showMessage('error', 'msg-erro-mes-inicial-final', true);
                valido = false;
            } else {
                let validaInicio = new Date(this.mes.ini);
                let validaFim = new Date(this.mes.fim);

                let numMeses = this.diferencaMeses(validaInicio, validaFim);
                if (numMeses > 24) {
                    this.$root.showMessage(
                        'error',
                        'msg-erro-periodo-maior-que-permitido-mes',
                        true
                    );
                    valido = false;
                }
            }
            return valido;
        },
        validateDatas() {
            let valido = true;
            let inicio = this.$moment(this.datainicio);
            let fim = this.$moment(this.datafim);

            if (fim.isBefore(inicio)) {
                this.$root.showMessage('error', 'msg-erro-data-inicial-final', true);
                valido = false;
            } else {
                let validaInicio = new Date(this.datainicio);
                let validaFim = new Date(this.datafim);

                let numDias = this.diferencaDias(validaInicio, validaFim);
                if (numDias > 31) {
                    this.$root.showMessage(
                        'error',
                        'msg-erro-periodo-maior-que-permitido-dia',
                        true
                    );
                    valido = false;
                }
            }
            return valido;
        },
        diferencaMeses(inicio, fim) {
            let month = fim.getMonth() - inicio.getMonth();
            let year = fim.getYear() - inicio.getYear();

            return month + year * 12;
        },
        diferencaDias(inicio, fim) {
            let diferenca = fim.getTime() - inicio.getTime();
            let dia = diferenca / (1000 * 3600 * 24);

            return dia;
        },
        limparFiltros() {
            this.vendedoresSelected = [];
            this.tipoPedidoSelected = [];
            this.atributoOptionSelected = [];
            this.formaPagamentoSelected = [];
            this.statusSelected = null;
            this.mes.ini = this.$moment().subtract(1, 'month').toDate();
            this.mes.fim = this.$moment().toDate();
            this.datainicio = this.$moment().subtract(1, 'month').toDate();
            this.datafim = new Date();
        },
        clearSelect(value, select) {
            if (value.length == 0) {
                if (select == 'vendedores') {
                    this.vendedoresSelected = [];
                } else if (select == 'atributo') {
                    this.atributoOptionSelected = [];
                } else if (select == 'formaPagto') {
                    this.formaPagamentoSelected = [];
                } else if (select == 'status') {
                    this.statusSelected = null;
                }
            }
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        onFilterChange() {
            setTimeout(() => {
                this.resize();
            }, 1000);
        },
        resize() {
            let neededHeight = window.innerHeight - document.querySelector('.page').offsetHeight;
            let needHeightFinal = neededHeight - 163;
            if (this.tableData.length > 0) {
                setTimeout(() => {
                    this.isFixedHeader =
                        needHeightFinal < document.querySelector('table.table').offsetHeight;
                    this.isFixedColumn = document.documentElement.clientWidth >= 768;

                    if (this.isFixedHeader) {
                        this.tableHeight = `${needHeightFinal}px`;
                    } else {
                        this.tableHeight = 'auto';
                    }
                }, 16);
            }
        },
        saveExportacao() {
            if (this.isNull(this.tituloExportacao)) {
                this.$root.showMessage('alert', 'msg-valida-titulo');
            } else {
                this.isSaving = true;
                this.isShowingTitle = false;
                let exportacao = {
                    idexportacao: null,
                    titulo: this.tituloExportacao,
                    processoexportado: this.tipoExportacao,
                    situacao: 'EXPORTANDO',
                    usuario: {
                        idusuarioerp: this.$store.state.user.idusuarioerp,
                    },
                    exportacaotipo: {
                        idexportacaotipo: this.exportacaoTipo.idexportacaotipo,
                        //IDEXPORTACAOTIPO (REFERE-SE A QUAL TELA ESTA CHAMANDO A EXPORTACAO)
                    },
                };
                // salva o inicio da gravação em fvw_exportacao
                this.exportacaoService
                    .save(exportacao)
                    .then((response) => {
                        this.$root.showMessage('success', 'msg-exp-solicitada');
                        this.saveLog(response.content, 'vendas-por-periodo');
                        this.gerarArquivoExportacao(response.content);
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar exportação.', e);
                        this.$root.showMessage('error', 'msg-erro-exp-gerar');
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            }
        },
        // Salva os dados na tabela fvw_exportacaolog
        saveLog(exportacao, tipo) {
            let exportacaoLog = {
                ///Objeto criado que será enviado ao banco
                destino: null,
                acao: 'Solicitação da exportação listagem ' + tipo,
                exportacao: exportacao,
                usuario: {
                    idusuarioerp: exportacao.usuario.idusuarioerp,
                },
            };
            this.exportacaoLogService
                .save(exportacaoLog)
                .then((r) => {})
                .catch((e) => {
                    console.error('Erro ao salvar log exportação.', e);
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');
                });
        },
        gerarArquivoExportacao(exportacao) {
            this.dataService
                .loadItens(0, 100, this.filtros)
                .then((value) => {
                    if (value.content) {
                        this.exportacao(exportacao, value.content);
                    }
                })
                .catch((error) => {
                    console.error('Erro ao trazer dados de itens.', error);
                    this.showMessage('error', 'msg-erro-exp-gerar');
                });
        },
        exportacao(exportacao, content) {
            let exportacaoVendasPeriodo = {};
            let diaPeriodo = null,
                mesPeriodo = null;
            this.tableExportacao = content;

            this.tableExportacao.forEach((table) => {
                table.contribuicaoFormatted = this.formatContribuicao(table.contribuicao);
                table.idNomeItem =
                    table.idItem != 0
                        ? table.idItem +
                          ' - ' +
                          (this.tipoExportacao == 'pdf'
                              ? table.nomeItem
                              : this.removeAcentos(table.nomeItem))
                        : '';
            });

            if (this.isData) {
                diaPeriodo = this.periodosTable;
            } else {
                mesPeriodo = this.periodosTable;
            }

            exportacaoVendasPeriodo = {
                exportacao: exportacao,
                usuario: this.$store.state.user,
                relatorioList: this.tableExportacao,
                anoMesDias: diaPeriodo,
                mesAnos: mesPeriodo,
                data: this.isData,
                atributo: this.atributoTable,
            };

            this.exportacaoDadosService
                .saveVendasperiodo(exportacaoVendasPeriodo, this.tipoExportacao)
                .then((this.tituloExportacao = ''))
                .catch((e) => {
                    console.error('Erro ao salvar exportação', this.tipoExportacao, e);
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
    },
    computed: {
        visibleTableProps: function () {
            return this.tableProps.filter((p) => p.visible);
        },
        itemsDataTable: function () {
            return this.tableData.filter((d) => d.idItem != 0);
        },
        totalDataTable: function () {
            return this.tableData.find((d) => d.idItem == 0);
        },
    },
    watch: {
        tipoAnalise: {
            deep: true,
            handler: function () {
                if (this.tipoAnalise === 'pedido') {
                    this.loadStatusPedido();
                } else {
                    this.statusSelect = [];
                    this.statusSelectCompleto = [];
                    this.statusSelected = null;
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../mixins.scss';

$padding: 5px;
.dia-mes-filter {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    .columns {
        width: 100%;
    }
}
.column {
    @include default-size-column;
}

.data {
    display: inline-block;
}

.data-exporta {
    display: inline-block;
    padding: 0 4px 0 0;
}

.is-one-quarter {
    width: 50%;
}
.mt-2-custom {
    display: inline-block;
    padding: 19px 0 0 0;
}

#main {
    padding: 0 15px 15px 20px;
    min-height: 100%;
    font-size: 13px;
}

.page {
    position: relative;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    padding: 0.6rem 1rem 1rem 1rem;
    .v-select {
        height: 27px;
    }
}

.control-buttons {
    margin: 0;
}

.results-x {
    overflow-x: auto;
    width: 100%;
}
.table-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    width: 100%;

    .atributos {
        .atributo {
            width: 90px;
            padding: 0;
        }
    }
    .item {
        padding-right: 30px;
    }
}

.atrib-col {
    min-width: calc(min(350px, calc(30vw)));
}

.value-col {
    min-width: 170px;
}

.table-data {
    display: flex;
    align-items: center;

    .atributos {
        .atributo {
            padding: 0;
        }
    }

    &.numeric {
        justify-content: flex-end;
        white-space: nowrap;
        .atributo {
            text-align: right;
            padding: 0;
        }
    }
}

.drop-item {
    width: 100%;
    margin: 0px;
    padding: 0px;
    .text {
        float: left;
    }
    .item-icon {
        float: right;
        padding: 0px;
        margin-right: 0px !important;
    }
}

.order-icon {
    margin-right: 0px !important;
    margin-left: 0px !important;
}

.card {
    overflow: initial;
    color: $darker-gray-color;
    .card-header-title {
        color: $darker-gray-color;
        justify-content: space-between;
        padding: 0.3rem;
    }

    .card-content {
        padding: 0.9rem;

        .card-content-top {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
        }
    }
}

.filtro-header {
    display: flex;
    align-items: center;
}

.search-and-filter {
    padding: 20px 0 20px 0;
}

.export-opcoes {
    .modal {
        display: flex;
        justify-content: center;
    }
    .modal-content {
        width: 40% !important;
    }
    .modal-card {
        width: auto !important;
    }
    .titulo-input {
        width: 100%;
    }
    .form-buttons2 {
        top: 20px;
        display: flex;
        margin: 0 auto;

        .save-btn,
        .delete-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            color: $sovis-white;
            font-size: 12px;
            height: 47px;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px !important;
            @include gradient-button();
        }

        .delete-btn {
            right: 225px;
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
    .ok {
        margin: 0;
    }
}

@media screen and (max-width: 1023px) {
    .header-search {
        width: 100%;
    }
}

@media screen and (max-width: 640px) {
    .mt-2-custom {
        margin-top: 0;
        padding: 10px 0 0 0;
    }
}
</style>
